"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WrapperSessionImpl = /** @class */ (function () {
    function WrapperSessionImpl(session) {
        this.session = session;
    }
    WrapperSessionImpl.prototype[Symbol.asyncDispose] = function () {
        return this.close();
    };
    WrapperSessionImpl.prototype.run = function (query, parameters, transactionConfig) {
        return this.session.run(query, parameters, transactionConfig);
    };
    WrapperSessionImpl.prototype.beginTransaction = function (transactionConfig) {
        return this.session.beginTransaction(transactionConfig);
    };
    WrapperSessionImpl.prototype.executeRead = function (transactionWork, transactionConfig) {
        return this.session.executeRead(transactionWork, transactionConfig);
    };
    WrapperSessionImpl.prototype.executeWrite = function (transactionWork, transactionConfig) {
        return this.session.executeWrite(transactionWork, transactionConfig);
    };
    WrapperSessionImpl.prototype.lastBookmarks = function () {
        return this.session.lastBookmarks();
    };
    WrapperSessionImpl.prototype.close = function () {
        return this.session.close();
    };
    return WrapperSessionImpl;
}());
exports.default = WrapperSessionImpl;
